import gsap from "gsap";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(useGSAP);
gsap.ticker.lagSmoothing(0);

/**
 * Builds an animation without the ambient `gsap.context()` that happens to sit
 * on the call stack, so the animation is owned by the caller that also tears it
 * down.
 *
 * `useGSAP` hands out a `contextSafe` wrapper that adopts every animation
 * created while the wrapped handler runs, however far down the call stack it is
 * created. A release-tag click runs inside the pressed card's context and then
 * changes the filters, which unmounts that card; reverting its context would
 * kill an application-owned transition before its first tick, leaving whatever
 * that transition was meant to retire on screen.
 */
export function outsideGsapContext<T>(create: () => T): T {
  const active = gsap.context() as gsap.Context | undefined;
  if (!active) return create();

  let created: T | undefined;
  active.ignore(() => {
    created = create();
  });
  return created as T;
}

export { gsap, useGSAP };
